import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.substring(1)).get("session_id");

    const run = async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        localStorage.removeItem("mt_active_profile");
        window.location.replace("/day");
      } catch {
        window.location.replace("/");
      }
    };
    run();
  }, []);

  return <div className="min-h-screen bg-[#0B1120]" data-testid="auth-callback-screen" />;
};
